import PageTitle from "../../../layouts/PageTitle";
import React, { useState, useEffect, useReducer } from "react";
import './Overview.css'
import {
  GetBarbers,
  GetEvents,
  PostNotification,
  GetNotifications,
  DeleteNotification,
  GetConfig,
  GetPaymentServiceDetails,
  GetRoster
} from './Requests';
import { Button, Modal } from "react-bootstrap";
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';


const fullDaysOfWeek = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
]
const DaysToDisplay = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dev'
]
const reducer = (state, action) => {
  switch (action.type) {
    case 'addNotesOpen':
      return { ...state, addNotesOptions: true }
    case 'addNotesClose':
      return { ...state, addNotesOptions: false }
    default:
      return state
  }
}
const initialState = false;

const Overview = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [staffWorking, setStaffWorking] = useState()
  const [allStaff, setAllStaff] = useState()
  const [notWorkingStaff, setNotWorkingStaff] = useState()
  const [day, setDay] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [events, setEvents] = useState()
  const [note, setNote] = useState("");
  const [notifications, setNotifications] = useState([])
  const [barbersWithClash, setBarbersWithClash] = useState([])
  const [config, setConfig] = useState()
  const [paymentServiceDetails, setPaymentServiceDetails] = useState()
  const [roster, setRoster] = useState()

  useEffect(() => {
    const day = fullDaysOfWeek[new Date().getDay()]
    setDay(day)
    GetBarbersWrapper(day)
  }, []);

    function GetRosterWrapper()
    {
        GetRoster(new Date()).then((res) => {
          setRoster(res.data)
          console.log(res.data)
          console.log(allStaff)
          
        }).catch((error) => {
          // notifyError("There was an issue saving your leave, please try again, or contact support")
        }).finally((f) => {
          setIsLoading(false)
        })  
    }

  function GetBarbersWrapper(day) {
    setIsLoading(true)
    GetBarbers().then((res) => {
      setStaffWorking(res.data.filter(x => x[day].start !== null))
      setNotWorkingStaff(res.data.filter(x => x[day].start === null))
      setAllStaff(res.data)
      GetEventsWrapper(res.data)
    }).catch((error) => {
    })
  }

  function GetEventsWrapper(barbers) {
    GetEvents(new Date()).then((res) => {
      setEvents(res.data.filter(x => x.eventType === 1))
      hasOverlap(res.data.filter(x => x.eventType === 1), barbers);
    }).catch((error) => {
    }).finally((f) => {
      GetDashboardNotificationsWrapper()
    })
  }

  function hasOverlap(events, barbers) {
    setBarbersWithClash([])
    var barberIds = []
    if (events.lenth !== 0)
    {
      barbers.forEach(barber => {
        var barberFilteredEvent = events.filter(x => x.barberId === barber.barberId)
        const sorted = barberFilteredEvent.slice().sort((a, b) => new Date(a.startDateTime) - new Date(b.endDateTime));
        for (let i = 0; i < sorted.length - 1; i++) {
          const currentEnd = new Date(sorted[i].endDateTime);
          const nextStart = new Date(sorted[i + 1].startDateTime);
          if (currentEnd > nextStart) {
            // Overlap found
            barberIds.push(sorted[i].barberId)
            break;
          }
        }
      });
      setBarbersWithClash(barbers.filter(x => barberIds.includes(x.barberId)).map(a => a.name))
    }
  }

  function GetDashboardNotificationsWrapper() {
    GetNotifications().then((res) => {
      setNotifications(res.data)
    }).catch((error) => {
    }).finally((f) => {
      GetConfigWrapper()
    })
  }

  function GetConfigWrapper() {
    GetConfig().then((res) => {
      console.log(res.data)
      setConfig(res.data)
    }).catch((error) => {
    }).finally((f) => {
      GetPaymentServiceDetailsWrapper()
    })
  }

    function GetPaymentServiceDetailsWrapper()
    {
      GetPaymentServiceDetails().then((res) => {
        console.log(res.data)
        if (res.status === 200)
        {
          setPaymentServiceDetails(res.data)
        }
      }).finally(() => {
        GetRosterWrapper()
      })
    }

  function DeleteDashboardNotification(id) {
    DeleteNotification(id).then(() => {
      GetDashboardNotificationsWrapper()
    }).catch((error) => {
    }).finally((f) => {
    })
  }

  function OnNotesSubmit(e) {
    e.preventDefault();
    if(note !== null || note !== undefined || note !== "")
    {
      PostNotification(note).then((res) => {
        notifySuccess("Notification Added")
        setNote("")
        dispatch({ type: 'addNotesClose' })
        GetDashboardNotificationsWrapper()
      }).catch((error) => {
        notifyError("There was an issue adding your notification. Please try again or contact support")
        
      })
    }
  }

  return (
    <div>
      {isLoading ? <div className='overview-loader'></div> :
        <div>
          <ToastContainer />
          <Modal enforceFocus={false} className="modal fade" show={state.addNotesOptions} centered>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Notification</h5>
                <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => { dispatch({ type: 'addNotesClose' }); setNote("");}}></Button>
              </div>
              <div className="modal-body">
                <form className="comment-form" onSubmit={OnNotesSubmit}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="comment" className="text-black font-w500">New Notification</label>
                        <textarea
                          rows={5}
                          className="form-control"
                          name=""
                          placeholder=""
                          defaultValue={note}
                          maxLength={250}
                          onChange={(e) => setNote(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12" style={{ display: "flex", justifyContent: "flex-end" }}>
                      <button disabled={note === ""} className={note === "" ? "disabled-note-submit-button" : "note-submit-button"}>Add</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>

          <div className="dashboard-container">
            <div className="dashboard-card">
              <h1>{DaysToDisplay[new Date().getDay()]} {new Date().getDate()} {months[new Date().getMonth()]} {new Date().getFullYear()}</h1>
            </div>
          </div>
          {config.acceptOnlinePayments === true ?
            <div className="dashboard-container">
            <div className="dashboard-card">
              <div style={{ display: "flex", justifyContent: "center", textAlign:"center"}}>
                <h2 className="h2">Available Funds</h2>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p className="big-number">£{Number(paymentServiceDetails.availableFunds/100).toFixed(2)}</p>
              </div>
            </div>
            <div className="dashboard-card">
              <div style={{ display: "flex", justifyContent: "center", textAlign:"center"}}>
                <h2 className="h2" >Pending Funds</h2>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p className="big-number">£{Number(paymentServiceDetails.pendingFunds/100).toFixed(2)}</p>
              </div>
            </div>
          </div>
          :
          <></>
          }
          {/* <div className="dashboard-container"> */}
            {/* <div className="dashboard-card">
              <div style={{ display: "flex", justifyContent: "center", textAlign:"center"}}>
                <h2 className="h2" >Today's Appointments</h2>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p className="big-number">{events.length}</p>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <p className="subtext">{events.filter(x => x.isFirstAppointment).length === 1 ? "1 with a new customer" : events.filter(x => x.isFirstAppointment).length + " with new customers"}</p>
              </div>
            </div> */}
            {/* {
              allStaff.length === 0 ?
              <div className="background-red dashboard-card">
              <div style={{ display: "flex", justifyContent: "center", textAlign:"center" }}>
                <h2 className="h2" >No Staff members</h2>
              </div>
              <div style={{ display: "flex", justifyContent: "center", textAlign:"center"}}>
                You currently don't have any staff members set up, head over to the manage staff area to set up staff members
              </div>
            </div>
            :
            <div className="dashboard-card" >
            <div style={{ display: "flex", justifyContent: "center", textAlign:"center" }}>
              <h2 className="h2" >Staff Overview</h2>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p><span className="big-number">{staffWorking.length}<span className="small-number">/{allStaff.length}</span></span> working today</p>
            </div>
          </div>
            } */}
            {/* <div className="dashboard-card">
              <div style={{ display: "flex", justifyContent: "center", textAlign:"center" }}>
                <h2 className="h2" >Appointments by Staff</h2>
              </div>
              <ul className="staff-list">
                {staffWorking.map((staff, index) => {
                  return (
                    <li key={index}>{staff.name}<span>{(events.filter(x => x.barberId === staff.barberId)).length} {events.filter(x => x.barberId === staff.barberId & x.isFirstAppointment).length === 0 ? "" : "(" + ((events.filter(x => x.barberId === staff.barberId & x.isFirstAppointment)).length) + String.fromCodePoint(9733) + ")"}</span></li>
                  );
                })}
                <ul className="staff-list"></ul>
                {notWorkingStaff.map((staff, index) => {
                  return (
                    <li key={index} className="not-working">{staff.name}<span>{(events.filter(x => x.barberId === staff.barberId)).length}</span></li>
                  );
                })}
              </ul>
            </div> */}
            <div className="dashboard-container">
            <div className="data-table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Hours</th>
                      <th>Breaks</th>
                      <th>Appointments</th>
                      <th>Leave</th>
                    </tr>
                  </thead>
                <tbody>
            {roster.length === 0 ? <></>
            :
            roster.map((val, index) => (
                <tr key={index} style={{
                  backgroundColor: ((val.leaveId != null && (events.filter(x => x.barberId === val.staffId)).length !==0) || (val.workingHours === " - " && (events.filter(x => x.barberId === val.staffId)).length !==0))  ? "#ffb5b5ff" :val.leaveId !== null || val.workingHours === " - "  ? "#ebebebff" :  "white", 
                  // borderColor: ((val.leaveId != null && (events.filter(x => x.barberId === val.staffId)).length !==0) || (val.workingHours === " - " && (events.filter(x => x.barberId === val.staffId)).length !==0))  ? "#ffb5b5ff" :val.leaveId !== null || val.workingHours === " - "  ? "#ebebebff" :  "white" 

                  }}>
                  <td>{val.staffName}</td>
                  <td>{val.workingHours}</td>
                  <td>{val.breaks}</td>
                  <td>{(events.filter(x => x.barberId === val.staffId)).length} {events.filter(x => x.barberId === val.staffId & x.isFirstAppointment).length === 0 ? "" : "(" + ((events.filter(x => x.barberId === val.staffId & x.isFirstAppointment)).length) + String.fromCodePoint(9733) + ")"}</td>
                  <td>
                    {val.leaveId !== null ? ((new Date(val.startDateTime)).getDate()+"/" +(dayjs(val.startDateTime).month()+1) + " - " + (new Date(val.endDateTime)).getDate()+"/" +((dayjs(val.endDateTime)).month()+1)) : '-'}


                  </td>
              </tr>
            ))}
          </tbody>
                  
                </table>
            </div>
            </div>
            
          {/* </div> */}
          <div className="dashboard-container">
            <div className="dashboard-card">
              <div style={{ display: "flex" }}>
                <h2 className="h2" >Notifications</h2>
                <IconButton onClick={() => { dispatch({ type: 'addNotesOpen' }) }} aria-label="delete" size="large" style={{ justifyContent: "right", marginLeft: "auto" }}>
                  <AddCircleOutlineIcon style={{ justifyContent: "right" }} />
                </IconButton>
              </div>
              <ul className="notifications-list">
                {notifications.length === 0 ? "no notifications" : 
                notifications.map((notification, index) => {
                  return (
                    <div key={index} style={{display: "flex"}}>
                    <li style={{width: "90%"}}>{notification.notification}</li>
                    <IconButton onClick={() => { DeleteDashboardNotification(notification.id)  }} style={{marginLeft: "auto"}} aria-label="delete" size="large">
                      <DeleteIcon/>
                    </IconButton>
                    </div>
                  );
                })}
              </ul>
            </div>
            <div className={barbersWithClash.length === 0 ? "dashboard-card" : "background-red dashboard-card"}>
              <div style={{ display: "flex", justifyContent: "center", textAlign:"center" }}>
                  <h2 className="h2" >Appointment Overlaps</h2>
              </div>
              <ul className="staff-list">
              {barbersWithClash.length === 0 ?
              <div style={{ display: "flex", justifyContent: "center" , textAlign:"center"}}>
              <li className="not-working">No overlaps</li>
              </div>
              :
              barbersWithClash.map((barber, index) => {
                return (
                  <li>{barber}</li>
                );
              })}
              </ul>
            </div>
            {/* {(config.phoneNumber === null)  ?
                        <div className="background-red dashboard-card">
                        <div style={{ display: "flex", justifyContent: "center", textAlign:"center" }}>
                            <h2 className="h2" >Details missing</h2>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center" , textAlign:"center"}}>
                        Shop details are  missing from your settings. Please fill out these details so that your customers are able to find and contact you when they need
                        </div>
                      </div>
                      :
                      <></>
            } */}
          </div>
        </div>
      }
    </div>
  );

}

export default Overview;